import { Phone, CalendarDays } from "lucide-react";
import { Link } from "react-router-dom";
import { CLINIC } from "../lib/api";

/**
 * Mobile-only bottom action bar.
 *
 * - Visible only on screens < md (`md:hidden`) so it never overlaps
 *   desktop content, footer, or hero.
 * - Two discrete buttons: „Sună” (telefon) și „Solicită programare”.
 * - The main layout keeps a bottom safe-area spacer (see PublicLayout)
 *   so the bar does not cover the footer, harta sau textele finale.
 */
export default function MobileBottomBar() {
  return (
    <div
      className="md:hidden fixed bottom-0 inset-x-0 z-40 border-t border-brand-beige bg-white/95 backdrop-blur-md shadow-[0_-6px_16px_-8px_rgba(33,108,114,0.18)]"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      data-testid="mobile-bottom-bar"
      role="navigation"
      aria-label="Acțiuni rapide"
    >
      <div className="grid grid-cols-2 gap-2 px-3 py-2">
        <a
          href={CLINIC.phoneTel}
          aria-label={`Sună la ${CLINIC.phonePretty}`}
          className="inline-flex items-center justify-center gap-2 rounded-full bg-brand-red text-white font-semibold py-2.5 text-sm active:scale-[0.98] transition-transform"
          data-testid="mobile-bar-call"
        >
          <Phone className="w-4 h-4" />
          Sună
        </a>
        <Link
          to="/programare"
          aria-label="Solicită o programare"
          className="inline-flex items-center justify-center gap-2 rounded-full bg-brand-navy text-white font-semibold py-2.5 text-sm active:scale-[0.98] transition-transform"
          data-testid="mobile-bar-book"
        >
          <CalendarDays className="w-4 h-4" />
          Solicită programare
        </Link>
      </div>
    </div>
  );
}
